export function randomRange (min: number, max: number) {
  if (max === undefined) {
    max = min;
    min = -max;
  }
  return Math.random() * (max - min) + min;
}

export function seededRandom (seed: number): [() => number, (min: number, max?: number) => number] {
  const random = () => {
    const x = Math.sin(seed++);
    return x - Math.floor(x);
  };

  const range = (min: number, max: number) => {
    if (max === undefined) {
      max = min;
      min = -max;
    }
    return random() * (max - min) + min;
  };

  return [
    random,
    range
  ];
}
